/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../states/user/userSlice";
import customerServices from "../services/CustomerService";
import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";
const DashboardLayout = (props) => {
  const { confirm } = Modal;
  const dispatch = useDispatch();
  const { navigation, children } = props;
  const [iconStyle, setIconStyle] = useState(true);
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    navigate("/login");
  };
  useEffect(() => {
    customerServices
      .GetUser()
      .then((response) => {
        if (response.status) {
          dispatch(setUser(response.resultData));
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setIconStyle(false);
  }, []);
  return (
    <div className="dashboard">
      {/* Navbar */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="/"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
          {navigation !== "dashboard" && (
            <li className="nav-item">
              <span className="nav-link" onClick={() => navigate(-1)}>
                <i className="fa-solid fa-arrow-left"></i>
              </span>
            </li>
          )}
        </ul>
        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">
          <li className="nav-item d-flex align-items-center">
            <span className="" >
              {" "}
              <img src={user.image} alt="" className="img-circle " />
            </span>
            <div className="nav-item dropdown d-inline-block">
              <a className="nav-link d-flex align-items-center" data-toggle="dropdown" href="/">
                <h5 className="header-font mb-0">
                  {user.customerFirstName} {user.customerLastName}
                </h5>
              </a>
              <div className="dropdown-menu custom-dropdown p-0">
                <div className="border-bottom">
                  <Link
                    to="/profile"
                    className="text-decoration-none logout-font d-block ps-3 p-1"
                  >
                    PROFILE
                  </Link>
                </div>
                <div>
                  <Link
                    className="text-decoration-none logout-font p-1 d-block"
                    onClick={() => {
                      confirm({
                        title: (
                          <div style={{position:"relative"}}>
                            <span>Are you sure you want to logout?</span>
                            <CloseOutlined style={{
                            position: "absolute",
                            top: "-8px",
                            right: "-10px",
                          }}  onClick={()=>{Modal.destroyAll();}}/>
                          </div>
                        ),
                        okText: 'YES',
                        okType: 'danger',
                        cancelText: 'NO',
                        onOk() {
                          handleLogout();
                        },
                        onCancel() {
                          console.log('Cancel');
                        },
                      });
                    }}
                  >
                    LOGOUT
                  </Link>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </nav>
      {/* /.navbar */}
      {/* Main Sidebar Container */}
      <aside className="main-sidebar sidebar-dark-primary elevation-4 ">
        {/* Brand Logo */}
        <a
          className="brand-link d-flex align-items-center justify-content-center py-2 second-img"
        >
          <img
            src="/logo-dark.png"
            alt="Logo"
            className="logo-dark first-img"
            style={{ opacity: ".8" }}
          />
         
          <span className="second-img"> <img src="/favicon.ico" /></span>
        </a>
        {/* Sidebar */}
        <div className="sidebar">
          {/* Sidebar user panel (optional) */}

          {/* SidebarSearch Form */}

          {/* Sidebar Menu */}
          <nav className="mt-5">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              <li className="nav-item">
                <Link
                  to="/dashboard"
                  className={`nav-link ${
                    navigation === "dashboard" ? "active" : ""
                  } `}
                >
                  <i className="nav-icon fa-solid fa-gauge "></i>
                  <p>Dashboard</p>
                </Link>
              </li>
              <li className={`nav-item ${iconStyle ? "menu-open" : ""}`}>
                <Link
                  to=""
                  className={`nav-link ${
                    navigation === "singlememberllc" ||
                    navigation === "multimemberllc" ||
                    navigation === "ndabuilder"
                      ? "active"
                      : ""
                  } `}
                  onClick={() => {
                    setIconStyle(!iconStyle);
                  }}
                >
                  <i className=" nav-icon fa-solid fa-gavel "></i>
                  <p>
                    Legal Tools
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link
                      to="/legaltools/singlememberllc"
                      className={`nav-link ${
                        navigation === "singlememberllc" ? "active" : ""
                      } `}
                    >
                      <i className="far fa-circle nav-icon" />
                      <p>Single Member LLC </p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/legaltools/multimemberllc"
                      className={`nav-link ${
                        navigation === "multimemberllc" ? "active" : ""
                      } `}
                    >
                      <i className="far fa-circle nav-icon" />
                      <p>Multi-Member LLC </p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="/legaltools/ndabuilder"
                      className={`nav-link ${
                        navigation === "ndabuilder" ? "active" : ""
                      } `}
                    >
                      <i className="far fa-circle nav-icon" />
                      <p>NDA Builder</p>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link
                  to="/paymenthistory"
                  className={`nav-link ${
                    navigation === "paymenthistory" ? "active" : ""
                  } `}
                >
                  {/* <i className="fa-solid fa-file mx-2"></i> */}
                  <i className="nav-icon fa-solid fa-money-check-dollar "></i>
                  <p>Payment History</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/agreement"
                  className={`nav-link ${
                    navigation === "agreement" ? "active" : ""
                  } `}
                >
                  {/* <i className="fa-solid fa-file mx-2"></i> */}
                  <i className="nav-icon fa-solid fa-file-contract "></i>
                  <p>TERMS</p>
                </Link>
              </li>
            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>
      {/* Content Wrapper. Contains page content */}
      {children}
      {/* /.content-wrapper */}
      <footer className="main-footer text-white">
        <strong>
          &copy; 2024{" "}
          <a href="https://foundrylawgroup.com/" target="_blank">
            Foundry Law Group
          </a>
          .{" "}
        </strong>
        All Rights Reserved.
      </footer>
      {/* Control Sidebar */}
      <aside className="control-sidebar control-sidebar-dark">
        {/* Control sidebar content goes here */}
      </aside>
      {/* /.control-sidebar */}
    </div>
  );
};

export default DashboardLayout;
